<!--begin::Signin-->
<div class="login-form login-signin ">


    <div class="pb-11 pt-lg-0 pt-5" *ngIf="!isFinish">
        <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
            Summary</h3>
    </div>




            <div class="row  d-flex justify-content-center ">
                <div class="col-12 ">
                    <div class="card user-card-full border-radius background-color">
                        <div class="row m-l-0 m-r-0">

                            <div class="col-sm-12 padding-14">
                                <div class="card-block">
                                    <div class="row">
                                        <div class="col-12 col-lg-6 align-self-center-sm">
                                            <p class="m-b-10 f-w-600" *ngIf="details?.executors.length ==1">Executor</p>
                                            <p class="m-b-10 f-w-600" *ngIf="details?.executors.length >1">Executors</p>
                                            <ng-container *ngFor="let item of details?.executors">
                                                <ng-container *ngIf="item?.isSelected == true">
                                                    <h6 class="text-muted f-w-400 color-black">{{item?.name | titlecase}}</h6>
                                                </ng-container>
                                            </ng-container>
                                            <!-- <h6 class="text-muted f-w-400 color-black">Blaise Mcdonalds</h6>
                                            <h6 class="text-muted f-w-400 color-black">Dela Cruz</h6> -->
                                        </div>
                                        <div class="col-12 col-lg-6 align-self-center-sm">
                                            <p class="m-b-10 f-w-600" *ngIf="details?.backup_executors.length ==1">Backup Executor</p>
                                            <p class="m-b-10 f-w-600" *ngIf="details?.backup_executors.length >1">Backup Executors</p>
                                            <ng-container *ngFor="let item of details?.backup_executors">
                                                <ng-container *ngIf="item?.isSelected == true">
                                                    <h6 class="text-muted f-w-400 color-black">{{item?.name  | titlecase}}</h6>
                                                </ng-container>
                                            </ng-container>
                                            <!-- <h6 class="text-muted f-w-400 color-black">Christian Dela Cruz</h6>
                                            <h6 class="text-muted f-w-400 color-black">Grace Jung</h6> -->
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 " *ngIf="!isFinish">

                    <div class="row" style="margin: 0">
                        <div class="pb-lg-0 pb-5 mt-4 ">
                            <button type="button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-9 width-150" (click)="editProfile()">
                                Edit
                            </button>
                        </div>


                        <!--begin::Action-->
                        <!-- <div class="pb-lg-0 pb-5 mt-4 margin-l-20">
                            <button id="kt_login_signin_submit" class="btn-save font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3 margin-left-auto width-150"  (click)="navigateToNextPage()">
                                Next
                            </button>
                        </div> -->


                    </div>

                </div>

            </div>




</div>



